import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import "@fontsource/open-sans";
import "./index.css";
import App from "./components/App";
import CaptchaComponent from "./components/captcha";
ReactDOM.render(React.createElement(React.StrictMode, null,
    React.createElement(Provider, { store: store },
        React.createElement(CaptchaComponent, null,
            React.createElement(BrowserRouter, null,
                React.createElement(App, null))))), document.getElementById("root"));
